import { createRequestHelper } from '@utils/swr'
import { type TokenMultiLoginRequest } from '../types/apiRequest'
import { type TokenMultiLoginResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['post']['tokenMultiLogin'], TokenMultiLoginResponse, TokenMultiLoginRequest>({
  client: 'fortune',
  key: params => params?.campaign_code && params.cosign_token
    ? `/campaigns/${params.campaign_code}/member/token_multi_login`
    : null,
  fetcher: client => (_, params) => {
    return client.post(`/campaigns/${params?.campaign_code}/member/token_multi_login`, {
      cosign_token: params?.cosign_token,
      campaign_code: params?.campaign_code,
    })
  },
  isImmutable: true,
})

export const useApiTokenMultiLogin = useRequest
